// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useCallback, useState } from 'react';
import TextInput from '../Form/TextInput';
import FormDialog from './FormDialog';

type DialogProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: ((participantAgent: string) => Promise<unknown>) | undefined;
};

export const ParticipantAgentDialog = ({ open, onClose, onSubmit }: DialogProps) => {
  const [participantAgent, setParticipantAgent] = useState<string>('');

  const resetState = useCallback(() => {
    setParticipantAgent('');
  }, [setParticipantAgent]);

  const handleClose = useCallback(() => {
    resetState();
    onClose();
  }, [resetState, onClose]);

  const handleSubmit = useCallback(() => {
    if (onSubmit) {
      return onSubmit(participantAgent).finally(() => {
        handleClose();
      });
    }
    handleClose();
    return Promise.resolve();
  }, [handleClose, onSubmit, participantAgent]);

  return (
    <FormDialog
      open={open}
      title="Participant Agent"
      onCancel={handleClose}
      onSubmit={handleSubmit}
      submitName="Accept"
      isSubmitDisabled={!participantAgent}
    >
      <TextInput
        label="Participant Agent Party"
        value={participantAgent}
        setValue={setParticipantAgent}
        required
      />
    </FormDialog>
  );
};
